import React from "react";
import { BonusDetail } from "../interfaces/BonusDetail";
import { BonusSourceDetails } from "../interfaces/BonusSourceDetails";
import Bonus from "./gridCells/Bonus";

interface Props {
  bonusSourceDetails: BonusSourceDetails;
  thirdColumn: boolean;
}

// TODO: show rank, but potentially have a flag to hide zero values or values at the default

export default ({ bonusSourceDetails, thirdColumn }: Props) => (
  <>
    {[
      ...bonusSourceDetails.rankIncreases,
      ...bonusSourceDetails.bonusesFromSources,
      ...bonusSourceDetails.targetedBonuses,
      ...bonusSourceDetails.progressionBonuses,
    ].reduce((agg: JSX.Element[], bonusDetail: BonusDetail, i) => {
      const bonusFromUpgradeId = `${i}_${bonusDetail.bonusDetailType}_${bonusSourceDetails.actualBonus.sourceKey}`;
      if (bonusDetail.sourceKey === "") {
        return agg;
      }
      return [
        ...agg,
        <Bonus
          key={bonusFromUpgradeId}
          dataTest={bonusFromUpgradeId}
          bonusDetail={bonusDetail}
          thirdColumn={thirdColumn}
        />,
      ];
    }, [])}
  </>
);
